import { Box, Grid, GridItem } from '@chakra-ui/react';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { ExtendedProfileInfo } from '@/components/ui/shared/profile/ExtendedProfileInfo/ExtendedProfileInfo';
import { ProfileInfoSkeleton } from '@/components/ui/shared/profile/ProfileInfo/ProfileInfo';
import { ContactProfileModal } from '@/components/ui/shared/profile/ProfilesList/components/ContactProfileModal';
import { queryAllLectureProfilesByLectureId } from '@/fetchers/lectureProfiles';
import { useResources } from '@/lib/datx-jsonapi-react';

export const AboutAuthorsPanel = () => {
  const { id } = useLecturePageQueryParams();

  const { data: lectureProfiles, error } = useResources(queryAllLectureProfilesByLectureId(id));

  return (
    <Box>
      {!lectureProfiles && !error && (
        <Grid mt={8} gap={10} templateColumns={['repeat(1, 1fr)', null, 'repeat(2, 1fr)']} alignItems="center" pr={4}>
          <GridItem>
            <ProfileInfoSkeleton />
          </GridItem>
          <GridItem>
            <ProfileInfoSkeleton />
          </GridItem>
        </Grid>
      )}

      <Box mt={4}>
        <Grid gap={10} templateColumns={['repeat(1, 1fr)', null, 'repeat(2, 1fr)']} alignItems="center">
          {lectureProfiles.map((profile) => (
            <GridItem key={profile.id}>
              <ExtendedProfileInfo
                profile={profile.profile}
                contactItem={
                  profile.profile.emailPublic &&
                  profile.profile.email && <ContactProfileModal profile={profile.profile} />
                }
              />
            </GridItem>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
